import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../../_shared/i18n/messages';

import DateTimePicker from '../DateTimePicker';

const propTypes = {

	/**
	 * The input name.
	 */
	name: PropTypes.string.isRequired,

	/**
	 * The input value.
	 *
	 * For a single datetime, it should be a MomentJS object or formatted string.
	 */
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(moment),
	]),

	/**
	 * The default timezone to use. Optional — falls back to the viewer's own
	 * zone, since an embedded form renders wherever the learner is.
	 */
	defaultTimezone: PropTypes.string,

	/**
	 * True, if editing the input value.
	 */
	isEditing: PropTypes.bool,

	/**
	 * True, if the input value is invalid.
	 */
	isInvalid: PropTypes.bool,

	/**
	 * True, if the input value is required.
	 */
	isRequired: PropTypes.bool,

	/**
	 * Callback function to handle changes to the input value.
	 */
	onChange: PropTypes.func,

};

const DateTimeInput = (props) => {

	const {
		name,
		value,
		defaultTimezone = moment.tz.guess(),
		isEditing,
		isInvalid,
		isRequired,
		onChange,
	} = props;

	// Stored values are ISO strings; the picker works in zone-aware moments.
	let pickerValue;

	if (value) {
		pickerValue = moment.isMoment(value) ? value : moment.tz(value, defaultTimezone);
	}

	if (!isEditing) {

		return (
			<div>
				{value && moment(value).tz(defaultTimezone).format('YYYY-MM-DD h:mma')}
				{!value &&
					<span className="tc-material-input-display-empty-value">
						<FormattedMessage {...messages.TC_COMPONENTS_FORM_INPUT_TEXT_EMPTY_VALUE} />
					</span>
				}
			</div>
		);

	}

	return (
		<div className={`tc-material-input-datetime ${isInvalid ? 'tc-material-input-invalid' : ''}`}>
			<DateTimePicker
				name={name}
				value={pickerValue}
				defaultTimezone={defaultTimezone}
				isInvalid={isInvalid}
				isRequired={isRequired}
				onChange={onChange} />
		</div>
	);

};

DateTimeInput.propTypes = propTypes;

export default DateTimeInput;
